import { render, staticRenderFns } from "./RptAvgWeddingParty.vue?vue&type=template&id=26fa492e&scoped=true&"
import script from "./RptAvgWeddingParty.vue?vue&type=script&lang=js&"
export * from "./RptAvgWeddingParty.vue?vue&type=script&lang=js&"
import style0 from "./RptAvgWeddingParty.vue?vue&type=style&index=0&id=26fa492e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26fa492e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VDataTable,VRow,VTextField})
